import { api } from ".";

const endpoint = "/api/client-portal";

export const getPurchaseOrders = (qp) => {
  return api.get(`${endpoint}/purchase-orders`, { params: qp });
};

export const getPurchaseOrder = (id) => {
  return api.get(`${endpoint}/purchase-orders/${id}`);
};

export const getPurchaseOrderOperationStatus = (id) => {
  return api.get(`${endpoint}/purchase-orders/${id}/operation-status`);
};
